import React from 'react';
import { CheckIcon } from 'lucide-react';
import { audienceItems, timeValueTasks } from '../data/content';
export function Audience() {
  return <section className="w-full bg-stone-50 px-8 py-24 sm:px-14 sm:py-32" data-id="element-19" data-mp="3p26z2jkodvud">
      <div className="mx-auto grid max-w-6xl gap-14 lg:grid-cols-12" data-id="element-20" data-mp="6vsp0vpj2619">
        <div className="lg:col-span-7" data-id="element-21" data-mp="1v4wu6pkbj5g">
          <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-22" data-mp="1u39b2rd146u">
            Pentru cine este <em className="text-red-700" data-id="element-23" data-mp="gqkj3pjwiara">JUDO GATA™</em>?
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-slate-900/75" data-id="element-24" data-mp="btawsirt6f7o">Acest pachet este pentru tine dacă:</p>
          <ul className="mt-8 grid gap-x-8 border-t border-slate-900/15 sm:grid-cols-2" data-id="element-25" data-mp="pkfnuwh41z6e">
            {audienceItems.map(item => <li key={item} className="flex gap-3 border-b border-slate-900/10 py-4 leading-snug text-slate-900/80" data-id="element-26" data-mp="llzved29fyll">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-red-700" strokeWidth={2.5} aria-hidden="true" data-id="element-27" data-mp="ukk72u9el80b" />
                {item}
              </li>)}
          </ul>
          <p className="mt-8 font-serif text-xl italic leading-snug text-slate-900/80" data-id="element-28" data-mp="16f2quwed0hhd">
            Creat pentru antrenorii de judo care vor să petreacă mai puțin timp cu pregătirea și mai mult timp cu sportivii lor, pe tatami.
          </p>
        </div>

        <aside className="self-start rounded-3xl bg-slate-900 p-8 text-stone-50 sm:p-11 lg:col-span-5" data-id="element-29" data-mp="1kdsms8pg0b45">
          <h3 className="font-serif text-3xl leading-tight sm:text-4xl" data-id="element-30" data-mp="1pasvkrdofryy">Cât valorează timpul tău?</h3>
          <p className="mt-4 leading-relaxed text-stone-50/75" data-id="element-31" data-mp="1u9vq3hw16fso">
            Gândește-te câte ore pe săptămână îți ia pregătirea antrenamentelor:
          </p>
          <ul className="mt-5 divide-y divide-white/10 border-y border-white/10" data-id="element-32" data-mp="240qjd67p2fnm">
            {timeValueTasks.map(task => <li key={task} className="py-3 text-[15px] text-stone-50/85" data-id="element-33" data-mp="282u0obh1oegt">
                {task}
              </li>)}
          </ul>
          <p className="mt-6 leading-relaxed text-stone-50/75" data-id="element-34" data-mp="2d26niw7x1lje">
            Acum imaginează-ți un pachet bine organizat, care te ajută cu toate acestea – tot sezonul.
          </p>
          <p className="mt-4 font-serif text-xl italic leading-snug text-red-300" data-id="element-35" data-mp="8yd6qyyyb6b9">
            Nu mai trebuie să o iei de la zero.
          </p>
        </aside>
      </div>
    </section>;
}